<div class="container row">


    <ng-container *appHasPermission="'user_setting_tailvehicles'">
        <app-config-line
            [title]="
                ((userForm.bol_tail ? 'GENERAL.DEACTIVATE' : 'GENERAL.ACTIVATE') | translate) +
                ' ' +
                ('CONFIGURATION.SECTIONS.CONFIGURATION.ICONS_CONFIGURATION.VEHICLE_QUEUE.LABEL' | translate)
            "
            [withHr]="false"
            [description]="'CONFIGURATION.SECTIONS.CONFIGURATION.ICONS_CONFIGURATION.VEHICLE_QUEUE.DESCRIPTION' | translate"
        >
            <input type="text" name="checkbox_changeNroTail" [(ngModel)]="userForm.nro_points_tail" pInputText
                placeholder="Número de tramas" pTooltip="Ingrese el número de tramas en la cola"
                tooltipPosition="right" />
            <p-inputSwitch [(ngModel)]="userForm.bol_tail"></p-inputSwitch>
        </app-config-line>
    </ng-container>


    <ng-container *appHasPermission="'user_setting_tailvehicles'">
        <app-config-line
            [title]="
                ((showDirectionVehicles ? 'GENERAL.DEACTIVATE' : 'GENERAL.ACTIVATE') | translate) +
                ' ' +
                ('CONFIGURATION.SECTIONS.CONFIGURATION.ICONS_CONFIGURATION.VEHICLE_DIRECTION.LABEL' | translate)
            "
            [description]="'CONFIGURATION.SECTIONS.CONFIGURATION.ICONS_CONFIGURATION.VEHICLE_DIRECTION.DESCRIPTION' | translate"
        >
            <object data="assets/images/user_config/VehicleDirection.gif" style="width: 70px;"></object>
            <p-inputSwitch [(ngModel)]="showDirectionVehicles"
                (onChange)="changeDirectionVehiclesCheckbox()"></p-inputSwitch>
        </app-config-line>
    </ng-container>




    <ng-container *appHasPermission="'user_setting_busaddressing'">
        <app-config-line
            [title]="'CONFIGURATION.SECTIONS.CONFIGURATION.ICONS_CONFIGURATION.COLOR_CHANGE.LABEL' | translate"
            [description]="'CONFIGURATION.SECTIONS.CONFIGURATION.ICONS_CONFIGURATION.COLOR_CHANGE.DESCRIPTION' | translate"
        >
            <ng-container body
                *appHasPermission="['user_setting_statusVehicles','user_setting_statevehicle','user_setting_statecursor','user_setting_stateonda']">
                <div class="container mb-3 contenido_checkbox">
                    <div class="row d-flex" style="justify-content: space-around;">
        
                        <div class="col-4 checks" *appHasPermission="'user_setting_stateonda'">
                            <div class="flex align-items h-5 column">
                                <div class="d-flex align-items-center" style="width: 70px;height: 95px">
                                    <object data="assets/images/user_config/gifcompleto.gif"
                                        style="height: 60px;width: 70px;"></object>
                                </div>
                                <div class="d-flex justify-content-center">
                                    <label class="switch">
                                        <input [(ngModel)]="userForm.bol_ondas" name="bol_ondas" type="checkbox"
                                            (change)="switchActive(1);">
                                        <span class="slider"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
        
                        <div class="col-4 checks" *appHasPermission="'user_setting_statecursor'">
                            <div class="flex align-items h-5 column">
                                <div>
                                    <object data="assets/images/user_config/flecha3colores.gif"
                                        style="height: 90px;width: 70px"></object>
                                </div>
                                <div class="d-flex justify-content-center">
                                    <label class="switch">
                                        <input [(ngModel)]="userForm.bol_cursor" name="bol_cursor" type="checkbox"
                                            (change)="switchActive(2);">
                                        <span class="slider"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
        
                        <div class="col-4 checks" *appHasPermission="'user_setting_statevehicle'">
                            <div class="flex align-items h-5 column position-relative">
                                <div class="position-relative">
                                    <object data="assets/images/user_config/vista2bus.gif"
                                        style="height: 90px;width: 70px"></object>
                                </div>
                                <div class="d-flex justify-content-center">
                                    <label class="switch">
                                        <input [(ngModel)]="userForm.bol_vehicle" name="bol_vehicles" type="checkbox"
                                            (change)="switchActive(3);">
                                        <span class="slider"></span>
                                    </label>
                                    <span *ngIf="showIcon" class="d-flex align-items-center ps-2"
                                        style="position: absolute; top: 70px; width: 30%;" data-bs-toggle="tooltip"
                                        data-bs-placement="right"
                                        data-bs-title="Tenga cuidado en seleccionar un color parecido a los estados de los vehículos">
                                        <i class="fas fa-exclamation" style="font-size: 1.5rem; color: red;"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
        
                    </div>
                </div>
            </ng-container>
        </app-config-line>
    </ng-container>


    <app-config-line
        [title]="'Configuración de íconos y consumo de combustible'"
        [description]="'Personaliza los íconos de los diferentes tipos de vehículos y define el consumo de combustible por tipo, expresado en galones.'"
    >
        <div body class="col-12 d-flex flex-row justify-content-between align-items-center">
            <div class="table-container w-100">
                <table class="table">
                    <thead>
                        <tr class="gl-text-primary">
                            <th>{{ 'CONFIGURATION.SECTIONS.CONFIGURATION.ICONS_CONFIGURATION.VEHICLE_TYPE' | translate }}
                            </th>
                            <th>{{ 'CONFIGURATION.SECTIONS.CONFIGURATION.ICONS_CONFIGURATION.ICON_COLOR' | translate }}</th>
                            <th>{{ 'CONFIGURATION.SECTIONS.CONFIGURATION.ICONS_CONFIGURATION.FUEL_CONSUMPTION' | translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let item of typeVehiclesList; let i = index">
                            <tr>
                                <td class="gl-text-primary">
                                    <span>{{ item.var_nombre }}</span>
                                    <input type="hidden" [(ngModel)]="item.id" name="id_{{ i }}" />
                                </td>
                                <td>
                                    <input type="color" class="form-control form-control-color"
                                        [(ngModel)]="item.code_color" name="var_color_{{ i }}" [value]="item.code_color" />
                                </td>
                                <td>
                                    <input type="text" name="var_galon_{{ i }}" [(ngModel)]="item.var_galon" pInputText
                                        [placeholder]="'CONFIGURATION.SECTIONS.CONFIGURATION.ICONS_CONFIGURATION.GALLONS_QUANTITY' | translate" pTooltip="Ingrese la cantidad en galones"
                                        tooltipPosition="right" />
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </app-config-line>


    <hr class="my-3">

    <div class="col-12 d-flex flex-row justify-content-between align-items-center">
        <button class="btn-gl-save btn-dark-hover btn-sm w-100" [disabled]="loading"
            (click)="confirm()">{{'GENERAL.SAVE'|translate}}</button>
    </div>

</div>